<template>
  <el-dialog
    :title="title"
    :visible.sync="innerVisible"
    :width="dialogWidth"
    :close-on-click-modal="false"
    @close="closeHandler"
  >
    <el-form v-if="elementformulaEditable" inline>
      <el-form-item label="Account">
        <el-select ref="accountTitleRef" v-model="form.accountTitle" style="width: 300px;" :filterable="true" :clearable="true" placeholder="Please select">
          <el-option
            v-for="(item,index) in newAccountCollection"
            :key="index"
            :label="accountTitleLabelFun(item)"
            :value="item.accountTitle"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="Operator">
        <el-select v-model="form.operateMode" style="width: 80px;">
          <el-option label="+" :value="1" />
          <el-option label="-" :value="0" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="addAccountTitleBtnClickHandler">Add</el-button>
      </el-form-item>
    </el-form>
    <div>
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width:100%;height:300px;padding-left:2px"
      />
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="footer.gridOptions"
        :column-defs="columnDefs2"
        :row-data="footer.rowData"
        :auto-fit-content="false"
        class="accounting-document-grid accounting-document-grid-footer"
        style="width:100%;padding-left:2px"
      />
    </div>
    <div slot="footer" style="padding-right:280px">
      <el-button v-if="elementformulaEditable" type="primary" @click="saveHander">Confirm</el-button>
      <el-button @click="closeHandler">Cancel</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import * as statementElementDescriptionApi from '@/api/financeManage/statementElementDescription'
import * as NumberUtils from '@/utils/NumberUtils'
import { DocumentManage } from '@/utils/commonUtil'

export default {
  name: 'ElementFormulaEditDialog',
  props: {
    visible: { type: Boolean, required: true },
    atbDictionary: { type: Object, required: true },
    accountSet: { type: Object, default: null },
    elementformulaEditable: { type: Boolean, required: true, default: false },
    statementElementDescriptionUuid: { type: String, required: true },
    statementElementDescription: { type: Object, required: true },
    statementName: { type: String, required: true }
  },
  data() {
    return {
      documentManage: new DocumentManage(),
      innerVisible: false,
      form: {
        accountTitle: '',
        operateMode: 1
      },
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          sortable: false // 去掉每列的排序
        },
        suppressContextMenu: true
      },
      rowData: [],
      footer: {
        gridOptions: {
          alignedGrids: [],
          headerHeight: 0,
          suppressContextMenu: true,
          suppressRowSelection: true,
          suppressRowClickSelection: true,
          rowHeight: 30,
          defaultColDef: {
            suppressMenu: true,
            suppressMovable: true,
            headerClass: 'text-center'
          }
        },
        rowData: [
          {
            accountTitle: 'Total',
            ending: '',
            beginningYear: ''
          }
        ]
      }
    }
  },
  computed: {
    // 科目
    accountTitleCollection() {
      return this.accountSet ? this.accountSet.accountTitle : []
    },
    newAccountCollection() {
      if (!this.accountTitleCollection || !this.statementElementDescription) return []
      const list = []
      for (const title of this.accountTitleCollection) {
        if (title.accountTitle === this.statementElementDescription.elementNo) continue
        list.push(title)
      }
      return list
    },
    title() {
      return 'Edit statistical item: ' + this.statementElementDescription.elementNo + ' ' + this.statementElementDescription.name
    },
    columnDefs() {
      return [
        {
          headerName: 'Account', field: 'accountTitle', width: 200,
          valueFormatter: params => {
            return this.accountTitleFun(params.value)
          }
        },
        {
          headerName: 'Operator',
          field: 'operateMode',
          width: 100,
          valueFormatter: params => {
            return this.operateModeFun(params.value)
          },
          cellStyle: { textAlign: 'center' }
        },
        {
          headerName: this.endingHeadName(),
          field: 'ending',
          width: 140,
          valueFormatter: params => {
            return NumberUtils.formatRoundNumber(params.value, 2)
          },
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: this.beginningYearHeadName(),
          field: 'beginningYear',
          width: 140,
          valueFormatter: params => {
            return NumberUtils.formatRoundNumber(params.value, 2)
          },
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: '',
          hide: !this.elementformulaEditable,
          width: 80,
          cellRenderer: params => {
            const methodPath = this.documentManage.getPath('delete')
            const del = this.$t('CargoMsg.Cargo_Delete')
            return `<a onclick="${methodPath}('${params.rowIndex}')" style="color: red;text-decoration: underline;">${del}</a>`
          },
          cellStyle: { textAlign: 'center' }
        }
      ]
    },
    columnDefs2() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_AccountTitle'),
          field: 'accountTitle',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OperationSymbol'),
          field: 'operateMode',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PeriodEndAmount'),
          field: 'ending',
          width: 140,
          valueFormatter: params => {
            return NumberUtils.formatRoundNumber(params.value, 2)
          },
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OpeningAmountOfTheYear'),
          field: 'beginningYear',
          width: 140,
          valueFormatter: params => {
            return NumberUtils.formatRoundNumber(params.value, 2)
          },
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: '',
          hide: !this.elementformulaEditable,
          width: 80
        }
      ]
    },
    dialogWidth() {
      return this.elementformulaEditable ? '705px' : '625px'
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        // 加载列表数据
        this.loadData()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.$emit('close')
      }
    }
  },
  beforeMount() {
    const self = this
    this.documentManage.set('delete', function(data) {
      self.deleteClickHandler(data)
    })
  },
  methods: {
    async loadData() {
      if (!this.statementElementDescriptionUuid) return
      await this.fillItem(this.statementElementDescription)
      this.total()
    },
    accountTitleLabelFun(accountTitle) {
      return accountTitle ? accountTitle.accountTitle + ' ' + accountTitle.accountTitleName : ''
    },
    accountTitleFun(accountTitle) {
      return this.accountTitleLabelFun(this.getAccountTitle(accountTitle))
    },
    operateModeFun(value) {
      return value ? '+' : '-'
    },
    async addAccountTitleBtnClickHandler() {
      if (!this.form.accountTitle) return
      if (this.rowData.find(elementFormula => elementFormula.accountTitle === this.form.accountTitle) !== undefined) {
        this.$message.warning(this.form.accountTitle + ' already existed')
        return
      }
      const elementFormula = {}
      elementFormula.accountTitle = this.form.accountTitle
      elementFormula.operateMode = this.form.operateMode
      this.rowData.push(await this.creatItem(elementFormula))
      this.clearForm()
      this.total()
    },
    async creatItem(elementFormula) {
      const result = {}
      result.elementFormula = elementFormula
      result.accountTitle = elementFormula.accountTitle
      result.operateMode = elementFormula.operateMode
      const atb = this.getAccountTitleBalance(elementFormula.accountTitle)
      if (atb) {
        if (this.statementName.indexOf('ProfitLoss') !== -1) {
          result.beginningYear = atb.currentMonthTotalAmount
          result.ending = atb.currentYearTotalAmount
        } else {
          result.beginningYear = atb.beginningBalance
          result.ending = atb.currentMonthBalanceAmount
        }
      } else {
        result.beginningYear = 0
        result.ending = 0
      }
      return result
    },
    clearForm() {
      this.form.accountTitle = ''
      this.form.operateMode = 1
    },
    getAccountTitle(accountTitle) {
      if (!this.accountTitleCollection || !accountTitle) {
        return null
      }
      return this.accountTitleCollection.find(title => title.accountTitle === accountTitle)
    },
    getAccountTitleBalance(accountTitle) {
      return this.atbDictionary[accountTitle]
    },
    saveHander() {
      const elementFormulas = []
      for (const row of this.rowData) {
        elementFormulas.push(row.elementFormula)
      }
      this.statementElementDescription.elementFormula = elementFormulas
      this.statementElementDescription.calculatedItem = elementFormulas.length > 0 ? 1 : 0
      const loading = getLoading()
      statementElementDescriptionApi.save(this.statementElementDescription).then(resp => {
        this.closeHandler()
      }).finally(() => loading.close())
    },
    deleteClickHandler(rowIndex) {
      this.rowData.splice(rowIndex, 1)
    },
    closeHandler() {
      this.clearForm()
      this.$emit('close')
    },
    async fillItem(value) {
      this.rowData = []
      if (!value.elementFormula || value.elementFormula.length === 0) return
      for (const elementFormula of value.elementFormula) {
        this.rowData.push(await this.creatItem(elementFormula))
      }
    },
    // 合计
    total() {
      let ending = 0
      let beginningYear = 0
      for (const row of this.rowData) {
        if (row.operateMode === 1) {
          ending += Number(row.ending)
          beginningYear += Number(row.beginningYear)
        } else {
          ending -= Number(row.ending)
          beginningYear -= Number(row.beginningYear)
        }
      }
      this.footer.rowData[0].ending = ending
      this.footer.rowData[0].beginningYear = beginningYear
      this.footer.gridOptions.api.refreshCells({ force: true })
    },
    endingHeadName() {
      if (this.statementName.indexOf('ProfitLoss') !== -1) {
        return this.$t('CargoMsg.Cargo_CurrentYearAccumulatedAmount')
      } else {
        return this.$t('CargoMsg.Cargo_PeriodEndAmount')
      }
    },
    beginningYearHeadName() {
      if (this.statementName.indexOf('ProfitLoss') !== -1) {
        return this.$t('CargoMsg.Cargo_AmountOfCurrentMonth')
      } else {
        return this.$t('CargoMsg.Cargo_OpeningAmountOfTheYear')
      }
    }
  }
}
</script>

<style lang="scss">
.accounting-document-grid{
  .ag-cell-inline-editing {
    height: 100%!important;
  }
  .ag-header-cell{
    &.text-center {
      text-align: center;
      .ag-header-cell-text{
        display: inline;
        width: 100%;
        height: 100%;
        line-height: 64px;
      }
    }
    &::after {
      height: 48px;
    }
  }
  .ag-cell {
    border-right: 1px solid #d9dcde;
  }
  .ag-cell-inline-editing {
    height: 30px;
  }
  &-footer {
    height: 34px;
    .ag-theme-balham {
      min-height: 34px!important;
    }
  }
}

</style>
